import React, { useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { Link as RouterLink } from 'react-router-dom';
import { Link as ScrollLink } from 'react-scroll';
import ModalVideo from "react-modal-video";
import { getPayloadMedia } from "../../services/payloadService";
import parseHtml from "../../utils/parseHtml";
import "../../../node_modules/react-modal-video/scss/modal-video.scss";

export default function AboutSection({ data }) {
    const { titulo, contenido, imagen, videoUrl, imagenFondo, caracteristicas, ctaTitulo, ctaDescripcion, ctaLink, tipoCta, boton1Texto, boton1Url, boton2Texto, boton2Url, blockType, __component } = data;
    const ancla = blockType || __component?.split('.')[1] || 'about';
    const [videoModal, setVideoModal] = useState(false);

    return (
        <>
            <section className="section" id={ancla} style={{backgroundImage: imagenFondo ? `url(${getPayloadMedia(imagenFondo.url || imagenFondo[0]?.url)})` : '', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}>
                <Container>
                    <Row className="align-items-center">
                        <Col lg={6} md={6}>
                            <div className="position-relative me-lg-5">
                                <img
                                    src={getPayloadMedia(imagen?.url || imagen?.[0]?.url)}
                                    className="rounded img-fluid mx-auto d-block"
                                    alt={titulo}
                                   style={{ minHeight: '150px' }}
                                />
                                {videoUrl && (
                                    <div className="play-icon">
                                        <RouterLink to="#" onClick={() => setVideoModal(true)} className="play-btn lightbox">
                                            <i className="mdi mdi-play text-primary rounded-circle bg-white shadow"></i>
                                        </RouterLink>
                                    </div>
                                )}
                            </div>
                        </Col>

                        <Col lg={6} md={6} className="mt-4 pt-2 mt-sm-0 pt-sm-0">
                            <div className="section-title">
                                <h4 className="title mb-3">{titulo}</h4>
                                <div className="text-body mb-3">
                                    {parseHtml(contenido)}
                                </div>

                                {/* Lista de características */}
                                {caracteristicas && caracteristicas.length > 0 && (
                                    <ul className="list-unstyled text-muted mb-4">
                                        {caracteristicas.map((caracteristica, index) => (
                                            <li key={index} className="mb-2">
                                                <span className="text-primary h5 me-2">
                                                    <i className="uil uil-check-circle align-middle"></i>
                                                </span>
                                                {parseHtml(caracteristica.texto)}
                                            </li>
                                        ))}
                                    </ul>
                                )}

                                {/* CTA - Texto o Botones */}
                                {tipoCta === 'botones' && (boton1Texto || boton2Texto) ? (
                                    <div className="mt-4">
                                        <div className="d-flex gap-2">
                                            {boton1Texto && (
                                                boton1Url && boton1Url.startsWith('#') ? (
                                                    <ScrollLink
                                                        to={boton1Url.substring(1)}
                                                        spy={true}
                                                        smooth={true}
                                                        duration={500}
                                                        className="btn btn-primary"
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        {boton1Texto}
                                                    </ScrollLink>
                                                ) : (
                                                    <RouterLink to={boton1Url || "#"} className="btn btn-primary">
                                                        {boton1Texto}
                                                    </RouterLink>
                                                )
                                            )}
                                            {boton2Texto && (
                                                boton2Url && boton2Url.startsWith('#') ? (
                                                    <ScrollLink
                                                        to={boton2Url.substring(1)}
                                                        spy={true}
                                                        smooth={true}
                                                        duration={500}
                                                        className="btn btn-outline-primary"
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        {boton2Texto}
                                                    </ScrollLink>
                                                ) : (
                                                    <RouterLink to={boton2Url || "#"} className="btn btn-outline-primary">
                                                        {boton2Texto}
                                                    </RouterLink>
                                                )
                                            )}
                                        </div>
                                    </div>
                                ) : ctaTitulo && (
                                    <div className="d-inline-block">
                                        <div className="pt-3 d-flex align-items-center border-top">
                                            <i className="uil uil-envelope text-primary me-2 fs-1"></i>
                                            <div className="content">
                                                <p className="mb-0">{ctaTitulo}</p>
                                                {ctaLink && ctaLink.startsWith('#') ? (
                                                    <ScrollLink
                                                        to={ctaLink.substring(1)}
                                                        spy={true}
                                                        smooth={true}
                                                        duration={500}
                                                        className="text-dark h6"
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        {ctaDescripcion}
                                                    </ScrollLink>
                                                ) : (
                                                    <RouterLink to={ctaLink || "#"} className="text-dark h6">{ctaDescripcion}</RouterLink>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {videoUrl && (
                <ModalVideo
                    channel="youtube"
                    isOpen={videoModal}
                    videoId={videoUrl}
                    onClose={() => setVideoModal(false)}
                />
            )}
        </>
    );
}
